<!-- 侧边抽屉组件 -->
<template>
  <van-popup v-model="isShow"  @click-overlay="showChange"  position="right">
    <div class="drawer-model">
      <slot></slot>
      <div class="bottom-btns">
        <span @click="reset">重置</span>
        <span @click="confirm">确定</span>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
Vue.use(Popup)
export default {
  name: 'cc-drawer',
  props: {
    /**
     * 是否显示
     */
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {},

  data () {
    return {
      isShow: this.value

    }
  },

  computed: {

  },

  created () {
  },

  methods: {
    /**
     * @description 返回父组件布尔值
     */
    showChange () {
      this.$emit('input', false)
    },
    /**
     * @description 点击重置按钮
     */
    reset () {
      this.$emit('reset')
    },
    /**
     * @description 点击确定按钮
     */
    confirm () {
      this.$emit('confirm')
    }
  },
  watch: {
    value (val) {
      this.isShow = val
    }

  }
}

</script>
<style lang='scss' scoped>
.drawer-model{
  width: 90vw;
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 60px;
  box-sizing: border-box;
  .bottom-btns{
    border-top: 1px solid rgba(238,238,238,1);
    height: 60px;
    z-index: 10;
    width: 100%;
    position: fixed;
    right: 0;
    bottom: 0;
    span{
      width: 50%;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      font-size: 15px;
      &:nth-of-type(2){
        background: var(--APP_theme_color);
        color: #ffffff;
      }
    }
  }
}
</style>
